import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendImageStyle, BackendMutationUpdateImageStyleArgs } from 'src/types/backend';

import { FRAGMENT_IMAGE_STYLE } from './schema';

const MUTATION = gql`
  mutation UpdateImageStyle(
    $id: ID!
    $name: String!
    $customerResourceIds: [ID!]!
    $referenceImagesToRemove: [Int!]
  ) {
    updateImageStyle(
      id: $id
      name: $name
      customerResourceIds: $customerResourceIds
      referenceImagesToRemove: $referenceImagesToRemove
    ) {
      ...ImageStyle
    }
  }
  ${FRAGMENT_IMAGE_STYLE}
`;

type Variables = BackendMutationUpdateImageStyleArgs;
type Result = BackendImageStyle;

export const updateImageStyle = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
